import { ConfigurationHistory } from "@/model/data/security/ConfigurationHistory";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetConfigurationHistoryEventsResData extends ApiGenericResponse {
    configurationsHistory: Array<ConfigurationHistory>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ConfigurationsHistory) {
            this.configurationsHistory = new Array<ConfigurationHistory>();
            obj.ConfigurationsHistory.forEach((history) => {
                let h = new ConfigurationHistory();
                h.parse(history);
                this.configurationsHistory.push(h);
            });
        }
    }
}
